import { render, staticRenderFns } from "./choicePayType.vue?vue&type=template&id=0cdfb77c&scoped=true&"
import script from "./choicePayType.vue?vue&type=script&lang=js&"
export * from "./choicePayType.vue?vue&type=script&lang=js&"
import style0 from "./choicePayType.vue?vue&type=style&index=0&id=0cdfb77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdfb77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cdfb77c')) {
      api.createRecord('0cdfb77c', component.options)
    } else {
      api.reload('0cdfb77c', component.options)
    }
    module.hot.accept("./choicePayType.vue?vue&type=template&id=0cdfb77c&scoped=true&", function () {
      api.rerender('0cdfb77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/choicePayType.vue"
export default component.exports